<template>
  <v-container fluid>
    <div class="charts-page">
      <h1 class="page-title mt-5 mb-6">สถิติการสั่งซื้อ</h1>
      <v-row no-gutters class="d-flex justify-center mb-6">
        <v-col cols="12">
          <v-card>
            <v-card-text class="pa-6 pt-0 pb-0">
              <ApexChart
                ref="realtimeChart"
                :height="$vuetify.breakpoint.smAndDown ? 300 : 350"
                :options="graph.chartOptions"
                :series="graph.series"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
<!--
      <v-row no-gutters class="d-flex justify-space-between mt-3 mb-6">
        <h1 class="page-title mt-2 mb-6">ข้อมูลจัดส่งวันนี้</h1>
        <v-col cols="12" md="12">
          <v-card class="mx-1 mb-1">
            <v-card-text class="pa-6 pt-0">
              <v-data-table
                v-model="table.selected"
                :headers="table.headers"
                :items="table.desserts"
                item-key="orderId"
                :search="table.search"
              >
                <template v-slot:[`item.index`]="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:[`item.orderId`]="{ item }">
                  <a @click="orderId(item.orderId)" class="primary--text">
                    {{ item.orderId }}
                  </a>
                </template>

                <template v-slot:[`item.createDate`]="{ item }">
                  {{ formatDate(item.createDate) }}
                </template>

                <template v-slot:[`item.detail`]="{ item }">
                  <a
                    @click="showmodalstatus(item.orderId)"
                    class="primary--text"
                  >
                    รายละเอียด
                  </a>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    -->
      <!--modal Delivery-->
      <v-row>
        <v-dialog
          v-model="modalStatusDelivery"
          scrollable
          max-width="600px"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-card>
            <v-card-title>
              <span class="headline">รายละเอียดจัดส่ง</span>
            </v-card-title>
            <v-card-text>
              <v-container class="border">
                <v-col cols="12">
                  <v-text-field
                    :value="computedtransDate"
                    label="วันที่จัดส่ง"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.docEntry"
                    label="Draft No"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.transName"
                    label="ตัวแทนขนส่ง"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="data.trackingNo"
                    label="Tracking No."
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.transNumber"
                    label="ทะเบียน"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.tel"
                    label="เบอร์โทร"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model.number="data.boxCount"
                    label="จำนวนบรรจุ"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.other"
                    label="อื่น ๆ "
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="data.fileName != ''">
                  <a @click="ShowPicture()" class="primary--text">
                    แสดงรูปภาพ
                  </a>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="modalStatusDelivery = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- modal status Detail-->
      <v-row>
        <v-dialog
          v-model="modalStatusDetail"
          scrollable
          max-width="600px"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-card>
            <v-card-title>
              <span class="headline">ข้อมูลใบสั่งขาย</span>
            </v-card-title>
            <v-card-text>
              <v-container class="border">
                <v-data-table
                  :headers="tableStatusDetail.headers"
                  :items="tableStatusDetail.desserts"
                  item-key="StatusId"
                >
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:[`item.docDate`]="{ item }">
                    {{ formatDate(item.docDate) }}
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="modalStatusDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!--modal status-->
      <v-row>
        <v-dialog
          v-model="modalstatus"
          scrollable
          max-width="400px"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-card>
            <v-card-title>
              <span class="headline">รายละเอียดสถานะ</span>
            </v-card-title>
            <v-card-text>
              <v-container class="border">
                <v-data-table
                  v-model="tablestatus.selected"
                  :headers="tablestatus.headers"
                  :items="tablestatus.desserts"
                  item-key="StatusId"
                >
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:[`item.statusDate`]="{ item }">
                    {{ formatDate(item.statusDate) }}
                  </template>

                  <template v-slot:[`item.statusDesc`]="{ item }">
                    <a
                      @click="showstatusDetail(item)"
                      v-if="
                        item.statusId != 'N' &&
                          item.statusId != 'C' &&
                          item.statusId != 'Y' &&
                          item.statusId != 'A'
                      "
                      class="primary--text"
                    >
                      {{ item.statusDesc }}
                    </a>
                    <p v-else>{{ item.statusDesc }}</p>
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modalstatus = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>

    <v-dialog
      v-model="dialogimage"
      scrollable
      max-width="550px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <!--
        <v-card-title>
          <span class="headline">รายละเอียดจัดส่ง</span>
        </v-card-title>
        -->

        <v-card-text>
          <v-container>
            <v-row align-content="center">
              <v-col cols="12">
                <v-img
                  :src="imageitem"
                  contain
                  height="360"
                  width="480"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogimage = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import ApexChart from "vue-apexcharts";
import config from "@/config";
export default {
  components: {
    ApexChart,
  },
  data() {
    return {
      table: {
        search: "",
        selected: [],
        headers: [
          {
            text: "ลำดับ",
            align: "start",
            sortable: true,
            value: "index",
            //  width: "10%",
          },
          {
            text: "วันที่",
            sortable: true,
            value: "createDate",
          },
          {
            text: "เลขใบสั่งซื้อ",
            sortable: true,
            value: "orderId",
            //  width: "10%",
          },
          {
            text: "ผู้ติดต่อ",
            sortable: true,
            value: "name",
            width: "20%",
          },
          {
            text: "หมายเหตุ",
            // sortable: true,
            value: "remark",
            width: "20%",
          },
          {
            text: "รายละเอียด",
            // sortable: true,
            value: "detail",
            width: "20%",
          },
        ],

        desserts: [],
      },
      transDate: "",

      imageitem: "",
      dialogimage: false,

      modalStatusDetail: false,
      modalStatusDelivery: false,
      modalstatus: false,

      graph: {
        series: [
          {
            name: "ข้อมูลการสั่งซื้อ",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "line",
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: "straight",
          },

          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: [
              "ม.ค.",
              "ก.พ.",
              "มี.ค",
              "เม.ษ",
              "พ.ค.",
              "มิ.ย.",
              "ก.ค.",
              "ส.ค.",
              "ก.ย.",
              "ต.ค.",
              "พ.ย.",
              "ธ.ค.",
            ],
          },
        },
      },

      data: {
        docNo: "",
        transDate: "",
        transName: "",
        trackingNo: "",
        transNumber: "",
        tel: "",
        other: "",
        fileName: "",
        boxCount: "",
        docEntry: "",
      },

      tableStatusDetail: {
        search: "",
        selected: [],
        headers: [
          {
            text: "ลำดับ",
            align: "start",
            sortable: true,
            value: "index",
            //  width: "10%",
          },
          {
            text: "วันที่",
            //align: "start",
            sortable: true,
            value: "docDate",
            //  width: "10%",
          },
          {
            text: "เลขใบสั่งขาย",
            //align: "start",
            sortable: true,
            value: "saleOrder",
            //  width: "10%",
          },
          {
            text: "Draft No",
            sortable: true,
            value: "draftNo",
          },
        ],
        desserts: [],
      },

      tablestatus: {
        search: "",
        selected: [],
        headers: [
          {
            text: "ลำดับ",
            align: "start",
            sortable: true,
            value: "index",
            //  width: "10%",
          },
          {
            text: "วันที่",
            //align: "start",
            sortable: true,
            value: "statusDate",
            //  width: "10%",
          },
          {
            text: "สถานะ",
            //align: "start",
            sortable: true,
            value: "statusDesc",
            //  width: "10%",
          },
        ],
        desserts: [],
      },
    };
  },

  computed: {
    computedtransDate() {
      return this.data.transDate
        ? moment(this.data.transDate).format("DD/MM/YYYY")
        : "";
    },
  },

  /*
  watch: {
    transDate() {
      this.data.transDate = this.formatDate(this.data.transDate)
    },
  },
*/
  beforeMount() {},

  mounted() {
    this.GetDelivery();
    this.GetStatic();
  },

  methods: {
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },

    ShowPicture() {
      this.$http({
        method: "get",
        url: "api/customerorder/gettranspic/" + this.data.fileName,
        responseType: "arraybuffer",
      })
        .then((response) => {
          if (response.status == "200") {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            this.imageitem = url;
            this.dialogimage = true;
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            if (error.response.status == "401") {
              this.$swal.fire({
                icon: "error",
                title: "Authorize",
                text: "ไม่พบสิทธิ์การใช้งาน",
              });
            }
          } else {
            this.$swal.fire({
              icon: "error",
              text: error.response.data,
            });
          }
        });
    },

    async GetDelivery() {
      try {
        let fromDate = moment(new Date()).format("YYYY/MM/DD");
        let toDate = moment(new Date()).format("YYYY/MM/DD");

        var params = new URLSearchParams();

        params.append("fromdate", fromDate);
        params.append("todate", toDate);

        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/GetStatusDetail/" +
            localStorage.getItem("customerid") +
            "/" +
            "D",
          params: params,
        });

        // console.log(response);
        if (response.status == "200") {
          this.table.desserts = response.data.status;
        }
      } catch (error) {
        console.log(error);

        this.$swal.fire({
          icon: "error",
          title: "Alert",
          text: error.response.data,
        });

        /*
        if (error.status == '401') {
          this.$swal.fire({
            icon: 'error',
            title: 'Authorize',
            text: 'ไม่พบสิทธิ์การใช้งาน',
          })
        } else if (status == '403') {
          this.$swal.fire({
            icon: 'error',
            title: 'Alert',
            text: 'ไม่พบ  URL',
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Alert',
            text: error.response.data,
          })
        }
        */
      }
    },

    orderId(value) {
      this.$router.push("/Order/CreateOrder");
      this.$store.state.orderid = value;
    },

    async GetStatic() {
      try {
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/GetStatic/" + localStorage.getItem("customerid"),
        });

        if (response.status == "200") {
          let obj = [];
          response.data.data.forEach((key) => {
            let count = {};
            count = parseInt(key.count);
            obj.push(count);
            // this.graph.series.data.push(count)
          });

          this.$refs.realtimeChart.updateSeries(
            [
              {
                data: obj,
              },
            ],
            false,
            true
          );

          this.graph.series.data = obj;
          console.log(this.graph.series.data);

        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Alert",
          text: error.response.data,
        });
        /*
        if (error.status == '401') {
          this.$swal.fire({
            icon: 'error',
            title: 'Authorize',
            text: 'ไม่พบสิทธิ์การใช้งาน',
          })
        } else if (status == '403') {
          this.$swal.fire({
            icon: 'error',
            title: 'Alert',
            text: 'ไม่พบ  URL',
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Alert',
            text: error,
          })
        }

        */
      }
    },

    async showstatusDetail(value) {
      if (value.statusId == "O") {
        var detail = await this.$http({
          method: "get",
          url: "api/SaleOrderMemo/GetSaleOrderNumber/" + value.docRef,
        });

        if (detail.status == "200") {
          this.tableStatusDetail.desserts = detail.data.saleordermemodoc;

          this.modalStatusDetail = true;
        }
      } else if (value.statusId == "D") {
        var response = await this.$http({
          mothod: "get",
          url: "api/CustomerOrder/Transport/" + value.docRef,
        });

        if (response.status == "200") {
          // this.data.transDate = this.formatDate(response.data.data.transDate)
          this.data = response.data.data;

          this.modalStatusDelivery = true;
        }
      }
    },

    async showmodalstatus(value) {
      this.tablestatus.desserts = [];

      try {
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/GetStatus/" +
            localStorage.getItem("customerid") +
            "/" +
            value,
        });
        //  console.log(response);
        if (response.status == "200") {
          this.tablestatus.desserts = response.data.status;

          this.modalstatus = true;
        }
      } catch (error) {
        if (error.response.status == "401") {
          this.$swal.fire({
            icon: "error",
            title: "Authorize",
            text: "ไม่พบสิทธิ์การใช้งาน",
          });
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data,
          });
        }
      }
    },
  },
};
</script>

<style src="./Dashboard.scss" lang="scss" />
